import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0800e456"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "crud-table" }
const _hoisted_2 = {
  key: 0,
  class: "crud-table__header"
}
const _hoisted_3 = { class: "crud-table__title" }
const _hoisted_4 = { class: "crud-table__actions" }
const _hoisted_5 = {
  key: 1,
  class: "crud-table__error",
  role: "alert"
}
const _hoisted_6 = {
  key: 2,
  class: "crud-table__body"
}
const _hoisted_7 = {
  key: 3,
  class: "crud-table__footer"
}

import { ref } from 'vue'
import { ElLoading } from 'element-plus'
import { Refresh } from '@element-plus/icons-vue'
import type { CrudTableColumn } from '@/types/crud-config'

interface SortEvent {
  prop?: string
  order?: 'ascending' | 'descending' | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CrudTable',
  props: {
    rows: {},
    pageNo: {},
    pageSize: {},
    total: {},
    loading: { type: Boolean, default: false },
    errorMessage: { default: '' },
    emptyText: { default: '暂无数据' },
    pageSizes: { default: () => [10, 20, 30, 40, 100] },
    showPagination: { type: Boolean, default: true },
    border: { type: Boolean, default: true },
    stripe: { type: Boolean, default: true },
    rowKey: { default: 'id' },
    height: {},
    maxHeight: {},
    columns: { default: () => [] }
  },
  emits: ["page-change", "page-size-change", "sort-change", "selection-change", "row-click", "retry"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const vLoading = ElLoading.directive

const props = __props

const emit = __emit

const tableRef = ref()

const handleSelectionChange = (rows: unknown[]) => {
  emit('selection-change', rows)
}

const handleSortChange = (value: SortEvent) => {
  emit('sort-change', value)
}

const handleRowClick = (row: unknown, column: unknown) => {
  emit('row-click', row, column)
}

const getColumnValue = (column: CrudTableColumn, row: Record<string, any>) =>
  column.prop ? row[column.prop] : ''

__expose({ tableRef })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.$slots.title || _ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "title")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "actions"),
            _createVNode(_component_el_tooltip, {
              content: "刷新",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  disabled: _ctx.loading,
                  "aria-label": "刷新",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('retry')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Refresh), {
                      class: "crud-table__refresh-icon",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1),
          _createVNode(_component_el_button, {
            type: "text",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('retry')))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Refresh), {
                class: "crud-table__icon",
                "aria-hidden": "true"
              }),
              _createTextVNode(" 重新加载 ")
            ]),
            _: 1
          })
        ]))
      : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_el_table, {
            ref_key: "tableRef",
            ref: tableRef,
            data: _ctx.rows,
            border: _ctx.border,
            stripe: _ctx.stripe,
            "row-key": _ctx.rowKey,
            height: _ctx.height,
            "max-height": _ctx.maxHeight,
            style: {"width":"100%"},
            onSelectionChange: handleSelectionChange,
            onSortChange: handleSortChange,
            onRowClick: handleRowClick
          }, {
            empty: _withCtx(() => [
              _renderSlot(_ctx.$slots, "empty", {}, () => [
                _createElementVNode("span", null, _toDisplayString(_ctx.emptyText), 1)
              ])
            ]),
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default"),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                return (_openBlock(), _createBlock(_component_el_table_column, {
                  key: column.prop || column.slot || column.label,
                  prop: column.prop,
                  label: column.label,
                  width: column.width,
                  "min-width": column.minWidth,
                  align: column.align,
                  sortable: column.sortable,
                  "show-overflow-tooltip": column.showOverflowTooltip,
                  fixed: column.fixed
                }, _createSlots({ _: 2 }, [
                  (column.slot || column.formatter)
                    ? {
                        name: "default",
                        fn: _withCtx((scope) => [
                          (column.slot)
                            ? _renderSlot(_ctx.$slots, column.slot, {
                                key: 0,
                                row: scope.row,
                                column: scope.column,
                                index: scope.$index
                              }, () => [
                                _createTextVNode(_toDisplayString(getColumnValue(column, scope.row)), 1)
                              ])
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(column.formatter?.(scope.row)), 1)
                              ], 64))
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["prop", "label", "width", "min-width", "align", "sortable", "show-overflow-tooltip", "fixed"]))
              }), 128))
            ]),
            _: 3
          }, 8, ["data", "border", "stripe", "row-key", "height", "max-height"])
        ])), [
          [_unref(vLoading), _ctx.loading]
        ]),
    (_ctx.showPagination)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_7, [
          _createVNode(_component_el_pagination, {
            "current-page": _ctx.pageNo,
            "page-size": _ctx.pageSize,
            "page-sizes": _ctx.pageSizes,
            total: _ctx.total,
            disabled: _ctx.loading,
            layout: "total, sizes, prev, pager, next, jumper",
            onSizeChange: _cache[2] || (_cache[2] = ($event: any) => (emit('page-size-change', $event))),
            onCurrentChange: _cache[3] || (_cache[3] = ($event: any) => (emit('page-change', $event)))
          }, null, 8, ["current-page", "page-size", "page-sizes", "total", "disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})